
var BillingPolicyBuilderErrors = {

  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    var field_names = ['name', 'code', 'terms', 'refundable_until_days', 'refundable_until_time', 'deposit_amount', 'deposit_percentage', 'deposit_days', 'collect_reservation_deposit', 'deposit_lifecycle_event', 'deposit_time_period', 'deposit_time_value', 'auth_balance_lifecycle_event', 'capture_balance_lifecycle_event', 'capture_balance_time_period', 'capture_balance_time_value'];

    for (var j = 0, jlen = field_names.length; j < jlen; j++) {
      var field_name = field_names[j];
      if (errors[field_name] && errors[field_name].length) {
        for (var i = 0, ilen = errors[field_name].length; i < ilen; i++) {
          err.push(I18n.t(field_name) + ' ' + errors[field_name][i]);
        }
      }
    }

    return err;
  },

  rates: function (errors) {
    var err = [];

    if (errors.rates && errors.rates.length) {
      for (var i = 0, ilen = errors.rates.length; i < ilen; i++) {
        err.push(errors.rates[i]);
      }
    }

    return err;
  },

	cancellation_rules: function(errors) {
		var err = [];

		if (errors.cancellation_rules && errors.cancellation_rules.length) {

			for (var i = 0, ilen = errors.cancellation_rules.length; i < ilen; i++) {
				err.push(errors.cancellation_rules[i]);
			}
		}

    var field_names = ['refundable_until_days', 'refundable_until_time'];

    for (var j = 0, jlen = field_names.length; j < jlen; j++) {
      var field_name = field_names[j];
      if (errors[field_name] && errors[field_name].length) {
        for (var i = 0, ilen = errors[field_name].length; i < ilen; i++) {
          err.push(I18n.t(field_name) + ' ' + errors[field_name][i]);
        }
      }
    }

		return err;
	},

}

export default BillingPolicyBuilderErrors
